<template lang="pug">

    div.mt-4(v-if="displayNotes")
        v-textarea.mt-0.pt-0.pr-3.pl-3(
            v-model="notes"
            :label="displayLabel"
            auto-grow
            :clearable="!readonly"
            hide-details
            :loading="saving"
            :readonly="readonly"
            rows="1"
            row-height="15"
            @blur="onBlur"
        )
        v-list-item.px-0.width-100-percent(v-if="!readonly")
            v-list-item-content.py-3.my-0.mr-8.width-100-percent.pt-1.pl-3(style='align-self: flex-start; display: flex; flex-direction: row; justify-content: flex-start; align-items: center; flex-wrap: nowrap;')
                v-switch.mt-0(
                    v-model="isPublicNote"
                    color="primary"
                    hide-details
                    :key="isPublicNote"
                    @change="onChangeIsPublicNote"
                )
                label.mb-0(class="v-label theme--light" style="font-size: 12px;")
                    template(v-if="!isPublicNote")
                        | Note will be private and hidden from agent
                    template(v-else)
                        | Note will be public and visible to agent

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                isPublicNote: false,
                notes: null,
            }
        },
        methods: {
            init() {
                if (!this.validItem) {
                    return;
                }

                this.notes = this.item.notes || null;
                this.isPublicNote = this.item.is_public_note || false;
                return;
            },
            onBlur() {
                if (this.readonly) {
                    return;
                }

                const options = {
                    notes: this.notes,
                    is_public_note: this.isPublicNote,
                }

                this.$emit('change', options)
            },
            onChangeIsPublicNote() {
                this.onBlur();
            },
        },
        computed: {
            displayNotes() {
                if (this.readonly) {
                    if (!this.validNotes) {
                        return false;
                    }

                    return (this.showPrivateNotes || this.isPublicNote);
                }

                return true;
            },
            displayLabel() {
                return this.label || 'Notes';
            },
            validNotes() {
                return this.notes?.length > 0;
            },
            validItem() {
                return this.item?.scorecard_id > 0;
            },
        },
        components: {
        },
        props: {
            item: Object,
            label: String,
            readonly: Boolean,
            saving: Boolean,
            showPrivateNotes: Boolean,
            showSnackbar: Function,
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
    #app {
    }
</style>
